import React, { useState, useEffect } from "react";
import BarTitle from "../../components/BarTitle";
import Toaster from "../../components/Toaster/Toaster";
import { fetchRainTax, setRainTax } from "../../services/rainTaxService";
import "./RainTax.css";

const RainTax = () => {
    const [clientValue, setClientValue] = useState(null);
    const [allfastValue, setAllfastValue] = useState(null);
    const [status, setStatus] = useState(true);
    const [responseMessage, setResponseMessage] = useState("");
    const [rainTaxData, setRainTaxData] = useState(null);
    const [showToaster, setShowToaster] = useState(false);

    useEffect(() => {
        const getRainTaxData = async () => {
            try {
                const data = await fetchRainTax();
                setRainTaxData(data);
                setClientValue(data.clientValue);
                setAllfastValue(data.allfastValue);
                const storedStatus = sessionStorage.getItem('rainTaxStatus');
                if (storedStatus !== null) {
                    setStatus(storedStatus === 'active');
                } else {
                    setStatus(data.status);
                    sessionStorage.setItem('rainTaxStatus', data.status ? 'active' : 'inactive');
                }
            } catch (error) {
                console.error("Error fetching rain tax data:", error);
            }
        };

        getRainTaxData();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await setRainTax({
                clientValue,
                allfastValue,
                status,
            });
            const statusMessage = status ? "Taxa de chuva ativa" : "Sem taxa de chuva";
            setResponseMessage(`Taxa alterada com sucesso! ${statusMessage}`);
            setShowToaster(true);

            const updatedData = await fetchRainTax();
            setRainTaxData(updatedData);
            sessionStorage.setItem('rainTaxStatus', status ? 'active' : 'inactive');
        } catch (error) {
            setResponseMessage("Error: " + error);
            setShowToaster(true);
        }
    };

    const handleCloseToaster = () => {
        setShowToaster(false);
    };

    const handleStatusChange = (e) => {
        const newStatus = e.target.checked;
        setStatus(newStatus);
        sessionStorage.setItem('rainTaxStatus', newStatus ? 'active' : 'inactive');
    };

    return (
        <div>
            <BarTitle name="Taxa da Chuva" />
            <div className="rain-tax-container">
                <form className="rain-tax-form" onSubmit={handleSubmit}>
                    <div>
                        <label>
                            Valor Debitado do Estabelecimento:
                            <input
                                type="number"
                                value={clientValue !== null ? clientValue : ""}
                                onChange={(e) => setClientValue(e.target.value)}
                            />
                        </label>
                    </div>
                    <div>
                        <label>
                            Valor Debitado do Allfast:
                            <input
                                type="number"
                                value={allfastValue !== null ? allfastValue : ""}
                                onChange={(e) => setAllfastValue(e.target.value)}
                            />
                        </label>
                    </div>
                    <div className="toggle-container">
                        <div className="grid-item">
                            <span>Ativar ou desativar taxa da chuva:</span>
                        </div>
                        <div className="grid-item">
                            <label className="toggle-label">
                                <input
                                    type="checkbox"
                                    checked={status}
                                    onChange={handleStatusChange}
                                    className="toggle-input"
                                />
                                <span className="toggle-slider"></span>
                            </label>
                            <span className="toggle-text">{status ? "Ativado" : "Desativado"}</span>
                        </div>
                    </div>

                    <button type="submit">Alterar</button>
                </form>
                {responseMessage && <p className="response-message">{responseMessage}</p>}
                {showToaster && <Toaster message={responseMessage} onClose={handleCloseToaster} />}
            </div>
        </div>
    );
};

export default RainTax;



// WEBPACK FOOTER //
// ./src/views/RainTax/index.js